import { render } from "./ShipmentList_item_default.vue?vue&type=template&id=0a42c319&scoped=true"
import script from "./ShipmentList_item_default.vue?vue&type=script&lang=js"
export * from "./ShipmentList_item_default.vue?vue&type=script&lang=js"

import "./ShipmentList_item_default.vue?vue&type=style&index=0&id=0a42c319&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a42c319"]])

export default __exports__